module.exports = __webpack_public_path__ + "img/flag-02.a71c03a7.svg";